"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSearchForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_picker_1 = require("@dzambalaorg/mui-inputs-picker");
const types_1 = require("@framework/types");
const mui_form_search_1 = require("@dzambalaorg/mui-form-search");
const OrderSearchForm = () => {
    return ((0, jsx_runtime_1.jsx)(mui_form_search_1.SearchWithFilters, { chipsKeys: ["orderStatus"], children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, spacing: 2, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 12 }, children: (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { multiple: true, options: types_1.OrderStatus, name: "orderStatus" }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 12 }, children: (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateRangeInput, { name: "dateRange" }) })] }) }));
};
exports.OrderSearchForm = OrderSearchForm;
//# sourceMappingURL=index.js.map